import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './i18n'; // if using i18n for translations
import './assets/css/contactform.css'
import './index.css';
// import './assets/css/Responsive.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
  
      <BrowserRouter>
        <App />
      </BrowserRouter>
  
  </HelmetProvider>
);
